import styled from "@emotion/styled"
import { PHeading } from "@porsche-design-system/components-react"
import { breakpoint, spacingStaticMd } from "@porsche-design-system/components-react/emotion"
import { Markdown } from "src/components"
import { whatsNewMessages } from "./whatsNew.messages"
import type { SupportedLanguage } from "./whatsNew.messages"

interface WhatsNewProps {
	language: SupportedLanguage
}

export const WhatsNewModalContent = ({ language }: WhatsNewProps) => {
	const messages = whatsNewMessages[language]

	return (
		<MarkdownWrapper>
			<PHeading tag="h3" size="md">
				{messages.subHeading}
			</PHeading>
			<Markdown value={messages.body} spacings />
		</MarkdownWrapper>
	)
}

const MarkdownWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: ${spacingStaticMd};

     @media (min-width: ${breakpoint.m}px) {
         max-width: 840px;
     }
`
